/**
 * @param {Response} response - Response object to check.
 * @returns {boolean} - Returns true if the response status is in the range 200-299, otherwise false.
 **/
export const isResponseOk = (response) => response && response.status >= 200 && response.status < 300;
